import { DADATA_TOKEN, DADATA_URL, URL } from './constants';
import { getToken, makeRequest } from './utils';

export const getLegalsRequest = parameters =>
	makeRequest(
		`${URL}/api/legals`,
		{
			method: 'GET',
			headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
		},
		parameters,
	);

export const getLegalInfoRequest = id =>
	makeRequest(`${URL}/api/legals/${id}`, {
		method: 'GET',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const createLegalRequest = payload =>
	makeRequest(`${URL}/api/legals`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const updateLegalRequest = (id, payload) =>
	makeRequest(`${URL}/api/legals/${id}`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getToken()}`,
		},
		body: JSON.stringify({ ...payload }),
	});

export const deleteLegalRequest = id =>
	makeRequest(`${URL}/api/legals/${id}`, {
		method: 'DELETE',
		headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
	});

export const getLegalsBySearchRequest = payload =>
	makeRequest(`${DADATA_URL}/suggest/party`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Token ${DADATA_TOKEN}`,
		},
		body: JSON.stringify({ query: payload }),
	});
